var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconLuggage = function SvgIconLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.268 2.484c1.027 0 1.864.827 1.864 1.846v.939c.163.087.3.215.399.372h1.692a3.292 3.292 0 0 1 3.293 3.285v9.813a2.783 2.783 0 0 1-2.784 2.777H5.268a2.783 2.783 0 0 1-2.784-2.777V8.926a3.292 3.292 0 0 1 3.293-3.285h1.692c.098-.157.236-.285.4-.372V4.33c0-1.019.836-1.846 1.863-1.846h4.536zm1.368 5.244H8.364v11.701h7.272V7.728zm-9.362 0h-.497c-.576 0-1.065.408-1.178.952l-.019.118-.006.128v9.813c0 .313.213.582.502.664l.099.02.093.006h1.006V7.728zm11.947 0h-.495v11.701h1.006a.696.696 0 0 0 .668-.5l.02-.098.006-.092V8.926c0-.574-.41-1.06-.956-1.173l-.119-.019-.13-.006zM14.04 4.57H9.959v.698c.106.056.201.13.283.22l.078.095-.02.057h3.344c.064-.102.145-.193.241-.27l.102-.07.056-.03v-.7z",
    fill: "var(--colors-brand)",
    fillRule: "evenodd"
  })));
};

export default SvgIconLuggage;